export default __webpack_public_path__ + "static/media/simon.74fc2eb9.png";